/* eslint-disable global-require */
import MicroModal from 'micromodal';
import carousel from './components/carousel/_carousel';
import accordion from './components/accordion/_accordion';
import videoModal from './components/videoModal/_videoModal';
import mainNav from './navigation/mainNav';
import mobileHeaderNavMain from './navigation/mobile/navigation';
import mobileHeaderNav from './navigation/mobile/mobile-nav';
import faqs from './pages/faqs';
// import acfMap from './acf/_acf-map';

const Site = () => {

    function mfReady(callbackFunc) {
        if (document.readyState !== 'loading') {
            // Document is already ready, call the callback directly
            callbackFunc();
        } else if (document.addEventListener) {
            // All modern browsers to register DOMContentLoaded
            document.addEventListener('DOMContentLoaded', callbackFunc);
        } else {
            // Old IE browsers
            document.attachEvent('onreadystatechange', () => {
                if (document.readyState === 'complete') {
                    callbackFunc();
                }
            });
        }
    }

    mfReady(() => {

        // Main header nav
        mainNav();

        // Mobile Navigation Set-up
        mobileHeaderNavMain();

        // Mobile Navigation Set-up
        mobileHeaderNav();

        // Video Modal
        videoModal();

        // Initialize Slick Carousels
        carousel();

        // Initialize Accordion
        accordion();

        faqs();

        // ACF Google map
        // acfMap();

        MicroModal.init({
            onClose: modal => {
                modal.querySelectorAll('.modal-video-embed').forEach(iframe => {
                    iframe.setAttribute('src', iframe.getAttribute('src'));
                });
            },
            disableScroll: true,
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
        });

    });
};

export default Site;
